import { render } from "./FooterCompo.vue?vue&type=template&id=0d02c392&scoped=true"
import script from "./FooterCompo.vue?vue&type=script&lang=js"
export * from "./FooterCompo.vue?vue&type=script&lang=js"

import "./FooterCompo.vue?vue&type=style&index=0&id=0d02c392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d02c392"]])

export default __exports__